import { SynchronizeAccountsApi } from "@/features/accounts/finance/services/synchronize-accounts-api";
import { SynchronizeAccountsRequestModel } from "@/features/accounts/finance/services/synchronize-accounts-model";

/// 銀行口座アカウント同期処理
export class SynchronizeAccountsService {
  private synchronizeAccountsApi = new SynchronizeAccountsApi();

  /**
   * 銀行口座アカウント同期API実行
   */
  public async synchronizeAccounts(param: SynchronizeAccountsRequestModel) {
    return await this.synchronizeAccountsApi.synchronizeAccounts(param);
  }
}
